import { IHousingObjectResponse } from '@/types';
import { IBrokerOfficeObjectResponse } from '@/types';
import { StructuredData } from '@/types/structuredData';
import { PATHS } from '@/constants';
import { generateBrokerDetailSchema } from './generateBrokerDetailSchema';
import { generateListingDetailSchema } from './generateListingDetailSchema';

const BASE_URL = process.env.BASE_URL ?? 'https://alleimmobilien.at';

export const generateBrokerPageSchema = (
  broker: IBrokerOfficeObjectResponse,
  objects: IHousingObjectResponse[],
  locale: string,
  section: 'housing' | 'project' = 'housing',
): StructuredData => {
  const brokerSlug = broker.directLink ?? broker.slug;
  const brokerId = `${BASE_URL}/${PATHS.BROKERS}/${brokerSlug}#broker`;

  const brokerSchema = {
    ...generateBrokerDetailSchema(broker),
    '@id': brokerId,
  };

  const listingNodes = objects.map((obj) => {
    const slugId = obj.slug ? `${obj.slug}__${obj.id}` : String(obj.id);
    const url = `${BASE_URL}/${locale}/${section}/${slugId}`;
    const listingId = `${url}#listing`;

    const listing = generateListingDetailSchema(obj, url);
    // заменяем вложенный agent на @id ссылку на брокера
    return {
      ...listing,
      '@context': undefined,
      '@id': listingId,
      agent: { '@id': brokerId },
    };
  });

  const itemList = {
    '@type': 'ItemList',
    name: `Objekte von ${broker.name}`,
    numberOfItems: objects.length,
    itemListElement: listingNodes.map((node, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: { '@id': node['@id'] },
    })),
  };

  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList', // required by StructuredData interface, overridden by @graph
    '@graph': [brokerSchema, ...listingNodes, itemList],
  };
};
